import { render, staticRenderFns } from "./RenovationPage.vue?vue&type=template&id=e72898f2&scoped=true&"
import script from "./RenovationPage.vue?vue&type=script&lang=js&"
export * from "./RenovationPage.vue?vue&type=script&lang=js&"
import style0 from "./RenovationPage.vue?vue&type=style&index=0&id=e72898f2&lang=scss&scoped=true&"
import style1 from "./RenovationPage.vue?vue&type=style&index=1&id=e72898f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e72898f2",
  null
  
)

export default component.exports